export default __webpack_public_path__ + "static/media/cardNoise.61eb9ae4.png";